module.exports = __webpack_public_path__ + "static/media/ddk-mainslide-04.cec3ecbf.jpg";